<template>
  <div id="wrapper">
    <div class="overlay-menu" id="overlay-menu"></div>
    <NavBar :user="user" :toggleMenu="toggleMenu" :toggleRightSidebar="toggleRightSidebar"  />
    <SideBar :is-condensed="isMenuCondensed" :toggleMenu="toggleMenu" />
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->

    <div class="content-page">
      <div class="content" :class="content_class">
        <!-- Start Content-->
        <div class="container-fluid px-0 mx-0">
          <slot />
        </div>
      </div>
    </div>
    <RightBar :toggleMenu="toggleMenu"/>
  </div>
</template>

<script>
import NavBar from '@components/nav-bar'
import SideBar from '@components/side-bar'
import RightBar from '@components/right-bar'

export default {
  components: { NavBar, SideBar, RightBar },
  props: {
    content_class: {
        type: String,
        required: false,
        default: ""
    },
  },
  data() {
    return {
      isMenuCondensed: false,
      user: this.$store ? this.$store.state.auth.currentUser : {} || {},
    }
  },
  watch: {
    isMenuCondensed(newVal, oldVal) {
      localStorage.setItem('isMenuCondensed', newVal);
    }
  },
  created: () => {
    // document.body.style.backgroundColor = '';
    document.body.classList.remove('authentication-bg')
    document.body.classList.remove('authentication-bg-pattern')
  },
  methods: {
    toggleMenu() {
      this.isMenuCondensed = !this.isMenuCondensed
      document.body.classList.toggle('sidebar-enable')
      document.body.classList.toggle('enlarged')
    },
    toggleRightSidebar() {
      document.body.classList.toggle('right-bar-enabled')
    }
  }
  // mounted: function(){
    // this.toggleMenu()
    // if (localStorage.getItem('isMenuCondensed') === 'true'){
    //   this.toggleMenu()
    // }
  // }
}
</script>

<style lang="scss">
.content.home {
  background-color: #e6e2e24f  !important;

  .container, .container-fluid {
    background-color: transparent !important;
    height: 100%;
    min-height: 100vh;
    padding-bottom: 10px;
  }
}
.content.home:before {
  content: ' ';
  display: block;
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 50%;
  background-image: linear-gradient(to top, rgba(237, 245, 247, 0.4), rgba(237, 245, 247, 0.9)), url("~~~@assets/images/login-bg-removebg.png");
  // background-size: cover;
  background-position: right bottom;
  background-repeat: no-repeat;
  opacity: 0.3
}
</style>